import "owl.carousel"
import 'magnific-popup'

jQuery(document).ready(function ($) {
  // MOBILE MENU
  $('.mobile-menu-icon').on('click', function () {
    $("#header-nav-wrapper").toggleClass('active')
    $(".line").toggleClass('active')
  })

  $('.nav-button').on('click', function () {
    if ($('#nav-menu').hasClass('active')) {
      $("#header-nav-wrapper").toggleClass('active')
      $(".line").toggleClass('active')
    }
  })

  // FAQ WIDGET
  $('.faq-widget .question').on('click', function (e) {
    e.preventDefault();

    const $clickedItem = $(this).closest('.faq-item');
    const $clickedAnswer = $clickedItem.find('.answer');
    const $icon = $(this).find('i');

    // Close all other answers and reset icons
    $('.faq-widget .answer').not($clickedAnswer).slideUp(250).removeClass('active');
    $('.faq-widget .question i').not($icon).removeClass('fa-chevron-down').addClass('fa-chevron-right');

    // Toggle current
    if ($clickedAnswer.hasClass('active')) {
      $clickedAnswer.slideUp(250).removeClass('active');
      $icon.removeClass('fa-chevron-down').addClass('fa-chevron-right');
    } else {
      $clickedAnswer.slideDown(250).addClass('active');
      $icon.removeClass('fa-chevron-right').addClass('fa-chevron-down');
    }
  });




  // CAROUSEL
  function createMainCarousel() {
    const mainCarousel = $("#main-carousel")

    mainCarousel.owlCarousel({
      loop: true,
      nav: false,
      dots: true,
      items: 1,
      startPosition: 0,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 1000,
      margin: 55,
      center: true,
      // responsive: {
      //   0: { 

      //   },
      //   700: {

      //   }
      // }
    })
  }
  createMainCarousel()


  function createTestimonialCarousel() {
    const testimonialCarousel = $("#testimonial-carousel");

    testimonialCarousel.owlCarousel({
      loop: true,
      nav: false,
      dots: true,
      startPosition: 0,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 2000,
      margin: 55,
      responsiveRefreshRate: 200,
      responsive: {
        0: {
          items: 1,
          center: true,
        },
        768: {
          items: 2,
          center: false,
        },
        992: {
          items: 3,
          center: true,
        }
      }
    });
  }

  createTestimonialCarousel()



  // NEWS SECTION LOGIC
  // Number of posts to reveal with each click
  const postsToShow = 5;

  function showMorePosts(containerId, buttonId) {
    // Show the next batch of hidden posts
    $(`${containerId} .hidden-post:hidden`).slice(0, postsToShow).slideDown().removeClass('hidden-post');

    // Check if there are any more hidden posts left
    if ($(`${containerId} .hidden-post:hidden`).length === 0) {
      // If no hidden posts remain, hide the button
      $(buttonId).hide();
    }
  }

  // Initial hide for additional posts
  $('.hidden-post').hide();

  // Corporate Press Releases Load More button
  $('#load-more-corporate').on('click', function () {
    showMorePosts('#corporate-press-container', '#load-more-corporate');
  });

  // EVENTS LOGIC
  const postsToReveal = 6;

  $('#show-more-events').on('click', function () {
    // Reveal the next batch of hidden posts
    $('.events-grid .hidden-post').slice(0, postsToReveal).slideDown().removeClass('hidden-post');

    // If no more hidden posts, hide the button
    if ($('.events-grid .hidden-post').length === 0) {
      $('#show-more-events').fadeOut();
    }
  });

  // Initially hide all posts marked with .hidden-post
  $('.events-grid .hidden-post').hide();

  // PAST EVENTS LOGIC
  const pastEventsToReveal = 12;

  $('#load-more-past-events').on('click', function () {
    $('.past-shows-grid .hidden-post').slice(0, pastEventsToReveal).slideDown().removeClass('hidden-post');

    if ($('.past-shows-grid .hidden-post').length === 0) {
      $('#load-more-past-events').fadeOut();
    }
  });

  // Initial hide
  $('.past-shows-grid .hidden-post').hide();


  // GALLERY SECTION LOGIC
  const galleryToShow = 12;

  function showMoreGallery() {
    $('.gallery-wrapper .hidden-gallery:hidden')
      .slice(0, galleryToShow)
      .each(function () {
        $(this).fadeIn(300).removeClass('hidden-gallery');
      });

    if ($('.gallery-wrapper .hidden-gallery:hidden').length === 0) {
      $('#load-more-gallery').fadeOut();
    }
  }

  // Hide extras on load
  $('.gallery-wrapper .hidden-gallery').hide();

  // Load more on click
  $('#load-more-gallery').on('click', function () {
    showMoreGallery();
  });



  // MAGNIFIC POPUP
  $('.gallery-wrapper').magnificPopup({
    delegate: 'a.popup-image', // child item selector, by class
    type: 'image',
    closeOnContentClick: true,
    mainClass: 'mfp-fade',
    image: {
      verticalFit: true
    },
    gallery: {
      enabled: true // allows next/prev in popup
    }
  });

  // ABOUT PAGE READ MORE
  $('.read-more-toggle').on('click', function () {
    const $content = $(this).siblings('.full-content');
    const isExpanded = $content.hasClass('expanded');

    $content.toggleClass('expanded');
    $(this).text(isExpanded ? 'Read More' : 'Show Less');
  });

  // ABOUT PAGE TAB NAVIGATION
  $('.tab-copy').hide().first().fadeIn();
  $('.tab').removeClass('active').first().addClass('active');

  $('.tab').on('click', function (e) {
    e.preventDefault();

    const target = $(this).attr('href');

    // Switch tab active state
    $('.tab').removeClass('active');
    $(this).addClass('active');

    // Fade content in/out
    $('.tab-copy').fadeOut(200);
    $(target).delay(200).fadeIn(300);
  });

});